/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ HOLDS FOOTER @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */
/* @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@ */

//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% ALERT %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
// %%%%%%%%%%%% NEEDS TO BE STYLED AND MAKE CONTENT CHANGES
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%% ALERT %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

import React from "react";
import { Link } from "gatsby";
// import 'bootstrap/dist/css/bootstrap.min.css'
import { Container, Row, Col } from "react-bootstrap";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faInstagram, faYoutube } from '@fortawesome/free-solid-svg-icons';
import "../styles/footer-styles.css";
import Crescat from "../images/crescat.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots
} from "@fortawesome/free-solid-svg-icons";


export default function Footer({ children }) {
  return (
    <footer>
      <Container>
        <Row className="justify-content-center">
          <Col xs={6} md={3}>
            <p>
              <strong>UChicago Summer Session</strong>              
              <br />
              Gates-Blake 505
              <br />
              5845 S. Ellis Avenue
              <br />
              Chicago, IL 60637 | P: 773-702-2149
            </p>
          </Col>
          <Col xs={6} md={3}>
            <ul>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
              <li>
                <Link to="/privacy-policy/">Privacy Notice</Link>
              </li>

              <li>
                <a
                  href="https://accessibility.uchicago.edu/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Accessibility
                </a>
              </li>
              <li>
                <a
                  href="//www.uchicago.edu/about/non_discrimination_statement/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Non-Discrimination
                </a>
              </li>
              <li>&nbsp;</li>
              
            </ul>
          </Col>
          <Col xs={6} md={3}>
            {/* <p>
              <strong>Hours</strong>
              <br />
              Monday — Friday
              <br />
              8:30 a.m. to 5 p.m.
              <br />
            </p> */}
            <ul>
              <li>
                <a href="https://applypcs.uchicago.edu/register/?id=85ec1fcc-2176-4f38-92f6-f62f040e4c4a" target="_blank">Join Our Mailing List</a>
              </li>
            </ul>
          </Col>

          <Col>
          <ul><li>
                <a
                  href="https://www.facebook.com/SummerUChicago/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <i class="fa-brands fa-square-facebook"></i>
                </a>
                <a
                  href="https://www.instagram.com/summeruchicago/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <i class="fa-brands fa-square-instagram"></i>
                </a>
                <a
                  href="tel:+773702-2149"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Phone"
                >
                  <i class="fa-solid fa-phone"></i>
                </a>
                <a
                  href="mailto:summersession@uchicago.edu"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Email"
                >
                  <i class="fa-solid fa-envelope"></i>
                </a>



              </li>
              
              
              
              <li>
            
              <a
                  href="mailto:summersession@uchicago.edu"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Feedback"
                  className="website-feedback"
                >
                    
                    <p> <i class="fa-solid fa-comment-dots"></i>
                      {/* <FontAwesomeIcon icon={faCommentDots} /> */}
                      Website Feedback</p>
                </a>


              </li>
              
              
              
              </ul>
          </Col>
          {/* <Col className="crescat" xs={6} md={3}>
            <img src={Crescat} alt="Crescate Scientia" loading="lazy" />
          </Col> */}
        </Row>
      </Container>
    </footer>
  );
}
